/* ==========================================================================
   NR - RECOMENDADOS EN EL CARRITO (16-10-2026)

   Para que: el pedido medio en España es 59,01 € y el envio gratis por
   importe esta en 80 €. Faltan 21 €. Este carrusel ofrece otro perfume
   dentro del propio carrito, que es el momento de maxima intencion.

   -------------------------------------------------------------------------
   LA TRAMPA QUE HAY QUE ESQUIVAR (comprobado el 16-10-2026)

   /recommendations/products.json devuelve en "price" el precio de la
   variante MAS BARATA del producto. En este catalogo casi todos los
   perfumes llevan muestra de 5 ml, asi que la API dice:

       KHAMRAH Lattafa ................ 5,50 €   (el frasco vale 40,00 €)
       CLUB DE NUIT URBAN MAN ELIXIR .. 5,50 €   (el frasco vale 50,00 €)
       RAYHAAN CADIZ .................. 5,50 €   (el frasco vale 48,95 €)

   Si se pintara "price" tal cual y el boton añadiera variants[0], el
   carrusel estaria empujando a la gente de un perfume de 45 € a una muestra
   de 5,50 €: BAJARIA el pedido medio en vez de subirlo. Que es justo lo
   contrario de para lo que se monta.

   Por eso aqui, de cada producto recomendado, se coge SIEMPRE la variante
   disponible MAS CARA (el frasco) y se pinta su precio.

   Y si la unica variante disponible es la muestra (porque el frasco esta
   agotado, como VULCAN LIMITED EDITION), el producto se descarta entero:
   ofrecer una muestra de 5,50 € a quien lleva 45 € en el carrito es peor
   que no ofrecer nada.
   -------------------------------------------------------------------------

   Reglas:
   - No recomienda nada que ya este en el carrito.
   - Si la peticion falla, no pinta nada. Nunca estorba al carrito.
   - Al añadir usa el parametro "sections" de Shopify, que es como refresca
     Dawn su propio cajon. Con /cart/add.js a secas el cajon se queda con el
     contenido viejo (y el boton de pagar aparece desactivado).

   Revertir: quitar las 2 lineas de nr-recomendados.* de
   snippets/nr-envio-gratis.liquid.
   ========================================================================== */
(function () {
  'use strict';

  var PRECIO_MINIMO = 1500;   // 15,00 € en centimos: por debajo es muestra
  var MAX_TARJETAS  = 6;
  var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var pintando = false;
  var firmaActual = '';

  function dinero(centimos) {
    return (centimos / 100).toFixed(2).replace('.', ',') + ' €';
  }

  /* De un producto de la API, la variante que de verdad interesa vender:
     la disponible mas cara. Devuelve null si no hay ninguna aprovechable. */
  function mejorVariante(producto) {
    var mejor = null;
    (producto.variants || []).forEach(function (v) {
      if (!v.available) return;
      if (mejor === null || v.price > mejor.price) mejor = v;
    });
    if (!mejor) return null;
    if (mejor.price < PRECIO_MINIMO) return null;   // solo queda la muestra
    return mejor;
  }

  function tarjeta(producto, variante) {
    var art = document.createElement('div');
    art.className = 'nr-reco__tarjeta';

    var img = document.createElement('img');
    img.className = 'nr-reco__foto';
    img.loading = 'lazy';
    img.width = 64;
    img.height = 64;
    img.alt = producto.title;
    var foto = variante.featured_image || producto.featured_image || (producto.images && producto.images[0]);
    if (foto) {
      var url = typeof foto === 'string' ? foto : foto.src;
      img.src = url.split('?')[0] + '?width=160';
    }
    art.appendChild(img);

    var datos = document.createElement('div');
    datos.className = 'nr-reco__datos';

    var a = document.createElement('a');
    a.className = 'nr-reco__nombre';
    a.href = raiz + 'products/' + producto.handle + '?variant=' + variante.id;
    a.textContent = producto.title;
    datos.appendChild(a);

    /* Solo se enseña la medida si el producto tiene mas de una variante:
       con una sola, "Default Title" no aporta nada. */
    if ((producto.variants || []).length > 1 && variante.title && variante.title !== 'Default Title') {
      var med = document.createElement('span');
      med.className = 'nr-reco__medida';
      med.textContent = variante.title;
      datos.appendChild(med);
    }

    var precio = document.createElement('span');
    precio.className = 'nr-reco__precio';
    precio.textContent = dinero(variante.price);
    if (variante.compare_at_price && variante.compare_at_price > variante.price) {
      var antes = document.createElement('span');
      antes.className = 'nr-reco__antes';
      antes.textContent = dinero(variante.compare_at_price);
      precio.appendChild(antes);
    }
    datos.appendChild(precio);
    art.appendChild(datos);

    var boton = document.createElement('button');
    boton.type = 'button';
    boton.className = 'nr-reco__add';
    boton.textContent = 'Añadir';
    boton.addEventListener('click', function () { anadir(variante.id, boton); });
    art.appendChild(boton);

    return art;
  }

  function anadir(idVariante, boton) {
    boton.disabled = true;
    var textoPrevio = boton.textContent;
    boton.textContent = '...';

    fetch(raiz + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify({
        items: [{ id: idVariante, quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (datos) {
        if (datos.status) throw new Error(datos.description || 'no se pudo añadir');
        boton.textContent = '✓';
        boton.classList.add('nr-reco__add--hecho');
        refrescarCajon(datos.sections);
      })
      .catch(function () {
        boton.disabled = false;
        boton.textContent = textoPrevio;
      });
  }

  /* Repinta el cajon con el HTML que devuelve Shopify. Se conserva el
     elemento <cart-drawer> (y por tanto la clase "active" que lo mantiene
     abierto): solo se cambia lo de dentro. */
  function refrescarCajon(secciones) {
    if (!secciones) return;
    try {
      var doc = new DOMParser();

      if (secciones['cart-drawer']) {
        var nuevo = doc.parseFromString(secciones['cart-drawer'], 'text/html').querySelector('cart-drawer');
        var actual = document.querySelector('cart-drawer');
        if (nuevo && actual) actual.innerHTML = nuevo.innerHTML;
      }

      if (secciones['cart-icon-bubble']) {
        var burbuja = doc.parseFromString(secciones['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        var destino = document.querySelector('#cart-icon-bubble');
        if (burbuja && destino) destino.innerHTML = burbuja.innerHTML;
      }
    } catch (e) { /* si falla, el carrito sigue bien: solo no se repinta */ }

    document.dispatchEvent(new CustomEvent('nr:carrito-actualizado'));
    setTimeout(montar, 150);
  }

  function flechas(carril) {
    var izq = document.createElement('button');
    var der = document.createElement('button');
    [izq, der].forEach(function (b) { b.type = 'button'; b.className = 'nr-reco__flecha'; });
    izq.innerHTML = '&#8592;';
    der.innerHTML = '&#8594;';
    izq.setAttribute('aria-label', 'Anterior');
    der.setAttribute('aria-label', 'Siguiente');

    function paso() { var t = carril.querySelector('.nr-reco__tarjeta'); return t ? t.getBoundingClientRect().width + 10 : 200; }
    izq.addEventListener('click', function () { carril.scrollBy({ left: -paso(), behavior: 'smooth' }); });
    der.addEventListener('click', function () { carril.scrollBy({ left: paso(), behavior: 'smooth' }); });

    function estado() {
      izq.disabled = carril.scrollLeft <= 2;
      der.disabled = carril.scrollLeft >= carril.scrollWidth - carril.clientWidth - 2;
    }
    carril.addEventListener('scroll', estado);
    setTimeout(estado, 60);

    var caja = document.createElement('div');
    caja.className = 'nr-reco__flechas';
    caja.appendChild(izq);
    caja.appendChild(der);
    return caja;
  }

  /* Firma del carrito: ids de variante y cantidades. Sirve para saber si el
     carrusel que hay pintado corresponde al carrito que hay AHORA.

     16-10-2026, fallo detectado en la primera prueba: al añadir KHAMRAH desde
     el carrusel, KHAMRAH seguia apareciendo entre los recomendados. Causa: el
     observador repinta el carrusel antes de que /cart.js refleje el alta, y la
     segunda llamada se salia porque ya habia un .nr-reco montado. Resultado:
     se podia añadir dos veces lo mismo y se desperdiciaba un hueco.
     Con la firma, si el carrito ha cambiado se tira el carrusel viejo y se
     vuelve a construir. Tambien cubre cambios de cantidad y borrados. */
  function firmaDe(carrito) {
    return carrito.items.map(function (i) { return i.variant_id + 'x' + i.quantity; }).join(',');
  }

  function montar() {
    if (pintando) return;
    var pie = document.querySelector('cart-drawer .drawer__footer');
    if (!pie) return;
    pintando = true;

    fetch(raiz + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (carrito) {
        if (!carrito.items || !carrito.items.length) throw new Error('carrito vacio');

        var firma = firmaDe(carrito);
        var yaPuesto = document.querySelector('cart-drawer .drawer__footer .nr-reco');
        if (yaPuesto) {
          if (yaPuesto.getAttribute('data-firma') === firma) throw new Error('ya esta al dia');
          yaPuesto.remove();   // el carrito ha cambiado: se reconstruye
        }
        firmaActual = firma;

        /* Semilla: el articulo mas caro del carrito. Es el que mejor define
           lo que esta buscando el cliente. */
        var semilla = carrito.items.slice().sort(function (a, b) { return b.price - a.price; })[0];
        var yaEstan = {};
        carrito.items.forEach(function (i) { yaEstan[i.product_id] = true; });

        return fetch(raiz + 'recommendations/products.json?product_id=' + semilla.product_id + '&limit=10&intent=related', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (datos) { return { productos: datos.products || [], yaEstan: yaEstan }; });
      })
      .then(function (ctx) {
        var utiles = [];
        ctx.productos.forEach(function (p) {
          if (utiles.length >= MAX_TARJETAS) return;
          if (ctx.yaEstan[p.id]) return;
          var v = mejorVariante(p);
          if (!v) return;
          utiles.push({ producto: p, variante: v });
        });
        if (!utiles.length) throw new Error('nada que recomendar');

        var pie = document.querySelector('cart-drawer .drawer__footer');
        if (!pie) throw new Error('sin pie');

        var caja = document.createElement('div');
        caja.className = 'nr-reco';
        caja.setAttribute('data-firma', firmaActual);

        var carril = document.createElement('div');
        carril.className = 'nr-reco__carril';
        utiles.forEach(function (u) { carril.appendChild(tarjeta(u.producto, u.variante)); });

        var cab = document.createElement('div');
        cab.className = 'nr-reco__cabecera';
        var h = document.createElement('h3');
        h.className = 'nr-reco__titulo';
        h.textContent = 'Combina bien con tu pedido';
        cab.appendChild(h);
        if (utiles.length > 1) cab.appendChild(flechas(carril));

        caja.appendChild(cab);
        caja.appendChild(carril);

        /* Primero el carrusel, luego el atomizador: primero el perfume de
           40 € y despues el complemento de 3,95 €, no al reves. */
        pie.insertBefore(caja, pie.firstChild);
      })
      .catch(function () { /* en silencio: el carrito nunca se rompe por esto */ })
      .then(function () { pintando = false; });
  }

  function arrancar() {
    montar();
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('#cart-icon-bubble, .cart-drawer__overlay, [name="add"], .product-form__submit')) {
        setTimeout(montar, 900);
      }
    }, true);
    document.addEventListener('nr:carrito-actualizado', function () { setTimeout(montar, 150); });

    /* Dawn repinta el cajon por su cuenta (al cambiar cantidades o borrar
       una linea) y se lleva por delante el carrusel. Se vuelve a montar. */
    var d = document.querySelector('cart-drawer');
    if (d && window.MutationObserver) {
      new MutationObserver(function () { setTimeout(montar, 120); })
        .observe(d, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
})();
